// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order {
  page-break-after: always;
}

.order:last-child {
  page-break-after: avoid;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td {
  border-bottom: 1px solid black;
  border-top: 1px solid black;
  text-align: left;
  padding: 8px;
}

th {
  border: none;
  text-align: left;
  padding: 8px;
}

p,
span {
  color: black;
}`, "",{"version":3,"sources":["webpack://./projects/zbs-app/src/app/modules/order/components/order-print/order-print.component.scss"],"names":[],"mappings":"AAAA;EACC,wBAAA;AACD;;AACA;EACC,uBAAA;AAED;;AACA;EACC,WAAA;EACA,yBAAA;AAED;;AACA;EACC,8BAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;AAED;;AAAA;EACC,YAAA;EACA,gBAAA;EACA,YAAA;AAGD;;AAAA;;EAEC,YAAA;AAGD","sourcesContent":[".order {\r\n\tpage-break-after: always;\r\n}\r\n.order:last-child {\r\n\tpage-break-after: avoid;\r\n}\r\n\r\ntable {\r\n\twidth: 100%;\r\n\tborder-collapse: collapse;\r\n}\r\n\r\ntd {\r\n\tborder-bottom: 1px solid black;\r\n\tborder-top: 1px solid black;\r\n\ttext-align: left;\r\n\tpadding: 8px;\r\n}\r\nth {\r\n\tborder: none;\r\n\ttext-align: left;\r\n\tpadding: 8px;\r\n}\r\n\r\np,\r\nspan {\r\n\tcolor: black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
